import { createUseStyles } from 'react-jss'
import { card } from '../../../../../../../styles/common'

export default createUseStyles({
  mediaCard: {
    extend: card,
    padding: 10,
    marginTop: 20
  },
  mediaTitle: {
    margin: '0'
  },
  filePreview: {
    margin: '12px 0'
  },
  text: {
    marginTop: 14
  },
  linkPreview: {
    lineBreak: 'anywhere'
  }
})
